export default {
  isValidUrl(value) {
    try {
      new RegExp("/spreadsheets/d/([a-zA-Z0-9-_]+)").exec(value)[1];
      return true;
    } catch (e) {
      return false;
    }
  },
}
